module.exports = __webpack_public_path__ + "img/empty-profile-picture.f2241ab0.png";